import { isElectron, room } from "../libs/roomnew";

export function getLocalAudioTrack(){
    if(room){
        return room.getLocalAudioTrack();
    }
    return null;
};

export const adjustSlider = (slider,value) => {
    const min = 0;
    const max = 1;
    // Calculate visible width
    const val = ((value - min) * 100) / (max - min);

    // Change these variables to the colors you need
    const fillLeft = "#7ea9d4";
    const fillRight = "#ffffff";

    slider.style.background = `linear-gradient(to right, ${fillLeft} ${val}%, ${fillRight} ${val}%`;
  };

  export function initBackdropLayer(){
    const images=[
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-2.jpg`,
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-1.jpg`,
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-3.jpg`,
        `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-4.jpg`
    ];
    const selectedImage=images[Math.floor(Math.random() * (images.length - 1))];
    $("#kino-end-backdrop").css('background-image',`url(${selectedImage})`)
}

export function showBackdropLayer(){
    $("#kino-end-backdrop").addClass('d-flex')
    setTimeout(() => {
        $("#kino-end-backdrop").addClass('backdrop-fadeIn')
    }, 100);
}

export function streamToBlob (stream, mimeType) {
    if (mimeType != null && typeof mimeType !== 'string') {
      throw new Error('Invalid mimetype, expected string.')
    }
    return new Promise((resolve, reject) => {
      const chunks = []
      stream
        .on('data', chunk => chunks.push(chunk))
        .once('end', () => {
          const blob = mimeType != null
            ? new Blob(chunks, { type: mimeType })
            : new Blob(chunks)
          resolve(blob)
        })
        .once('error', reject)
    })
  }


export async function readableStreamToBlob(readableStream) {
    const reader = readableStream.getReader();
    const chunks = [];
    let done, value;

    while ({ done, value } = await reader.read(), !done) {
        chunks.push(value);
    }

    return new Blob(chunks);
}
